import React from 'react'

import Text from '../../ui/text'

export const Edit = ({ value, onChange }) => (
  <Text type='date' value={value} onChange={onChange} />
)
